module.exports = __webpack_public_path__ + "img/background-study-registration@2x.12798bf3.jpg";